import React, { Suspense } from 'react';
import type { Props } from './CommentQuill';

const CommentQuillImpl = React.lazy(() => import('./CommentQuill'));

export { initialToolbar } from './CommentQuillConfig';

export default function CommentQuillLazy(props: Props) {
  return (
    <Suspense fallback={<div style={{ minHeight: props.minHeight || 60 }} />}>
      <CommentQuillImpl {...props} />
    </Suspense>
  );
}
